/**
 * @since 7.1.0
 */
export interface DeleteReminderOptions {
  /**
   * @since 7.1.0
   */
  id: string;
}
